import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/comissao')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_venda_comissao }) =>
                isPermissionParcialOrFull(upp_venda_comissao),
        }),
});
